var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10H13.3334L11.6667 12.5H8.33342L6.66675 10H1.66675",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54175 4.2585L1.66675 10.0002V15.0002C1.66675 15.4422 1.84234 15.8661 2.1549 16.1787C2.46746 16.4912 2.89139 16.6668 3.33341 16.6668H16.6667C17.1088 16.6668 17.5327 16.4912 17.8453 16.1787C18.1578 15.8661 18.3334 15.4422 18.3334 15.0002V10.0002L15.4584 4.2585C15.3204 3.98082 15.1077 3.74714 14.8442 3.58373C14.5807 3.42032 14.2768 3.33366 13.9667 3.3335H6.03341C5.72334 3.33366 5.41947 3.42032 5.15595 3.58373C4.89244 3.74714 4.67973 3.98082 4.54175 4.2585Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.1f2fcfe3.svg";
export { ForwardRef as ReactComponent };